import { getStream } from '../base/selectors';
import { OffsetStream } from './types';

function getOffsetStream<TItems = any, TParams extends object = any>(
  state,
  streamId: string
) {
  return getStream<TItems, TParams>(state, streamId) as OffsetStream<
    TItems,
    TParams
  >;
}

export const getNextOffset = (state, streamId: string) => {
  const stream = getOffsetStream(state, streamId);
  const { nextOffset, items } = stream;
  return nextOffset !== undefined && nextOffset !== null
    ? nextOffset
    : (items && items.length) || 0;
};

export const getPrevOffset = (state, streamId: string) => {
  return getOffsetStream(state, streamId).prevOffset || 0;
};
